import BaseComponent from '../../../../base/base_component';
import {SYSTEM_EVENTS} from '../../../../events/events';
import Event from '../../../../utils/event';

class BaseLayout extends BaseComponent {
    /**
     * @override
     */
    _layoutTypes;


    /**
     *
     * @param params
     */
    init(params) {
        super.init();
    }

    /**
     * Send analytic data specified on layout environment
     *
     * @private
     */
    _sendAnalytics({category='Client_LoginPost', action}) {
        let analyticObj = Object.assign({}, {category: category, action: action});
        if ('game' === this._stepParent.getEnvironment()) {
            analyticObj.category =  this._model.getIsReal() ? 'Client_GameFrame_Real' : 'Client_GameFrame_Anonymous';
            analyticObj.label = this._model.getGameType() + '_' + this._model.getGameName().replace(/ /g, '');
        }

        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, analyticObj);
    }
}

export default BaseLayout;